<template>
    <div class="content"
      @click="onMessageClick($event, message)"
      @dblclick="onMessageDoubleClick(message)"
      v-context-menu="{action: onMessageContextMenu, data: message}"
    >
        <div class="message">
            <div class="from" :title="message.sender.email || message.sender.name">
                <span class="sender-label" v-if="message.sender_label">
                  {{ Language.say('messages.sender_label.' + message.sender_label) }}
                </span>
                {{message.sender.name || message.sender.email}}
            </div>
            <div class="subject" :title="message.subject">
                {{message.subject}}
            </div>
        </div>

        <div class="meta">
            <div class="datetime">
                {{message.date.short}}
            </div>

            <div class="flags">
                <span v-for="flag in flags" :key="flag.name"
                  v-tooltip='`messages.flags.${flag.name}`'
                >
                  <i :class="flag.icon"></i>
                </span>

                <span v-if="message.flags.flagged"
                  @click.stop="onMessageUnflag(message)"
                  v-tooltip='"messages.actions.mark_unflagged"'
                  :class="{flagged: true}"
                  class="flag" role="button"
                >
                    <i class="fas fa-bookmark"></i>
                </span>

                <span v-else
                  @click.stop="onMessageFlag(message)"
                  v-tooltip='"messages.actions.mark_flagged"'
                  class="flag" role="button"
                >
                  <i class="far fa-bookmark"></i>
                </span>
            </div>
        </div>
  </div>
</template>

<script setup>
  import {defineEmits, defineProps} from 'vue';
  import {onBeforeMount, ref}       from 'vue';
  import Language                   from '@/js/Shared/Language/Language';

  const props = defineProps({
    message    : {},
    message_index : Number,
    show_flags : {
      default : true,
    }
  });

  const emit = defineEmits([
    'messageFlag', 'messageClick', 'messageDoubleClick', 'messageContextMenu',
  ])

  const flags_metadata = [
    {
      'name': 'forwarded',
      'icon': 'fas fa-mail-forward',
    },
    {
      'name': 'answered',
      'icon': 'fas fa-reply',
    },
    {
      'name': 'priority_low',
      'icon': 'fas fa-arrow-down',
    },
    {
      'name': 'forwarded',
      'icon': 'fas fa-share',
    },

    {
      'name': 'priority_high',
      'icon': 'fas fa-exclamation-circle',
    },
    {
      'name': 'attachments',
      'icon': 'fas fa-paperclip',
    },
  ]

  const flags = ref([]);

  onBeforeMount(() => {
    if (props.show_flags) {
      setFlags();
    }
  })

  const setFlags = () => {
    flags_metadata.forEach((flag) => {
      if (props.message.flags[flag.name]) {
        flags.value.push(flag);
      }
    })
  }

  const onMessageFlag = (message) => {
    emit('messageFlag', message);
  }

  const onMessageUnflag = (message) => {
    emit('messageUnflag', message);
  }

  const onMessageClick = ($event, message) => {
    emit('messageClick', $event, message);
  }

  const onMessageContextMenu = (message) => {
    emit('messageContextMenu', message);
  }

  const onMessageDoubleClick = (message) => {
    emit('messageDoubleClick', message);
  }

</script>